import { useContractorContext } from '@features/Contractor/ContractorContext'
import { EmployeeContextProvider } from '@features/Contractor/Employee/EmployeeContext'
import { getCoursesQuery, getEmployeeQuery } from '@services/queryOptions'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const EmployeeLayout: React.FC = () => {
  const { contractorId, employeeId } = Route.useParams()
  const { data: contractor, isLoading: isLoadingContractor } = useContractorContext()

  const employeeQuery = useQuery({
    ...getEmployeeQuery(contractorId, employeeId, contractor?.tenantId),
    enabled: !!contractor?.tenantId,
  })
  const coursesQuery = useQuery({
    ...getCoursesQuery(contractorId, contractor?.tenantId),
    enabled: !!contractor?.tenantId,
  })

  const isLoading = isLoadingContractor || employeeQuery.isLoading || coursesQuery.isLoading
  const isError = employeeQuery.isError || coursesQuery.isError

  const handleRefetch = () => {
    void employeeQuery.refetch()
    void coursesQuery.refetch()
  }

  return (
    <EmployeeContextProvider
      value={{
        data: employeeQuery.data,
        courses: coursesQuery.data?.items,
        isLoading,
        isError,
        refetch: handleRefetch,
      }}
    >
      <Outlet />
    </EmployeeContextProvider>
  )
}

export const Route = createFileRoute('/contractor/$contractorId/employees/$employeeId')({
  component: EmployeeLayout,
  staticData: {
    breadcrumb: t('contractor.editEmployee.title'),
  },
})
